<div class="nsc-page-title" *ngIf="content.pageTitle">
  <h1 class="mat-display-1">{{ content.pageTitle }}</h1>
  <h2 class="mat-typography" *ngIf="content.recipient">
    <strong>Recipient:</strong> {{ content.recipient }}
  </h2>

  <nsc-spacer size="md"></nsc-spacer>
</div>